<template>
  <div class="app-list">
    <div class="app-list_toolbar accent lighten-2 py-5 px-10 d-flex">
      <slot name="action-buttons"></slot>
      <div class="app-list__search">
        <slot name="search-box"></slot>
      </div>
    </div>
    <v-container class="mt-5">
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            Loading...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <error-alert :message.sync="error"></error-alert>
    <v-alert dismissible :type="alertType" v-model="displayAlert"> {{alertMessage}}</v-alert>
      <v-data-iterator
        :items="filteredItems"
        :items-per-page.sync="itemsPerPage"
        :page="pageNumber"
        no-data-text=""
        :footer-props="{ itemsPerPageOptions: itemsPerPageArray }"
        @update:page="updatePageNumber"
      >
        <template #default="props">
          <v-row>
            <v-col
              sm="12"
              md="6"
              xl="4"
              v-for="item in props.items"
              :key="item.id"
            >
              <v-card
                hover
                @click="goToSingleItem(item.id)"
                max-width="480"
                class="rounded-xl d-flex px-3 flex-column ma-auto"
              >
                <v-menu v-if="displayMenu" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      class="mt-1 mr-3 app-list__options"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <v-list color="grey lighten-3">
                    <slot
                      name="menu-options"
                      v-bind:item="item"
                    ></slot>
                  </v-list>
                </v-menu>
                <v-img
                  v-if="cardsWithImage"
                  lazy-src="/images/not-available.png"
                  :src="item[cardImageFieldName] ? item[cardImageFieldName] : '/images/not-available.png'"
                  height="150"
                ></v-img>
                <v-card-text class="d-flex my-2 flex-column">
                  <slot
                    name="app-item"
                    v-bind:item="item"
                  ></slot>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-container>
  </div>
</template>

<script>
import merge from "lodash.merge";

export default {
  props: {
    classes: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    goToSingleItem: {
      type: Function,
      default: () => {},
    },
    search: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: null,
    },
    cardsWithImage: {
      type: Boolean,
      default: false,
    },
     cardImageFieldName: {
      type: String,
      default: null,
    },
    alertMessage: {
      type: String,
      default: ''
    },
    alertType: {
      type: String,
      default: "success"
    },
    showAlert: {
      type: Boolean,
      default: false
    },
    pageNumber: {
      type: Number,
      required: true
    },
    updatePageNumber: {
      type: Function,
      required: true
    },
    displayMenu: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      itemsPerPage: 10,
      itemsPerPageArray: [10, 30, 60, 100],
    };
  },
  computed: {
    filteredItems() {
      const _self = this;
      if (this.search) {
        const filteredItems = this.items.filter(function (item) {
          const searchable = merge(item, item.user, item.catalytic_converters);
          delete searchable.user;
          delete searchable.catalytic_converters;
          const searchableValues = Object.values(searchable);
          const result = searchableValues.find((dataPoint) => {
            if (dataPoint) {
              return dataPoint.toString().toLowerCase().includes(_self.search.toLowerCase());
            }
            return false;
          });
          return result;
        });
        return filteredItems;
      }
      return this.items;
    },
    // https://github.com/vuejs/vue/issues/7434
    displayAlert: {
      get() { return this.showAlert},
      set(value) { return this.$emit("update:showAlert", value)}
    }
  },
};
</script>

<style scoped>
.app-list_toolbar {
  gap: 12px;
}
.app-list__search {
  margin-left: auto;
}
.app-list__options {
  position: absolute;
  right: 0px;
  z-index: 1;
}
</style>
